import {
  setSelectedHotel,
  setSelectedRegion,
  setSelectedCity,
  setSelectedDeal
} from "../actions/hotelsActions";
import { LOCATION_CHANGE } from "react-router-redux";
import { setActiveBreadCrumbs } from "../actions/breadCrumbsActions";
import qs from "qs";
import { BREAD_CRUMBS_ROUTE_MAPPING } from "../constants/constants";

export const routeChangeMiddleware = ({ dispatch }) => next => action => {
  if (action.type == LOCATION_CHANGE) {
    let query = qs.parse(action.payload.search, { ignoreQueryPrefix: true });
    action.payload &&
      action.payload.notifyRoute &&
      action.payload.notifyRoute(query && query.selectedHotelId);
    if (
      query.selectedHotelId ||
      query.selectedCityCode ||
      query.selectedRegionId ||
      query.selectedDealId
    ) {
      dispatch(setSelectedHotel(query.selectedHotelId));
      dispatch(setSelectedCity(query.selectedCityCode));
      dispatch(setSelectedRegion(query.selectedRegionId));
      dispatch(setSelectedDeal(query.selectedDealId));
    }
    let fullPath = action.payload && action.payload.pathname;
    let path = fullPath && fullPath.split("/");
    if (path && path[1] && BREAD_CRUMBS_ROUTE_MAPPING[path[1]]) {
      dispatch(setActiveBreadCrumbs(BREAD_CRUMBS_ROUTE_MAPPING[path[1]]));
    }
  }
  next(action);
};

// const normalizeSelectedValue = (val) => {
//     let result = val;
//     if (result) {
//         result = parseInt(result);
//     }
//     else {
//         result = null;
//     }
//     return result;
// };



// WEBPACK FOOTER //
// ./src/middlewares/routeChangeMiddleware.js